<template>
  <div id="PurchaseAnnouncement">
    <div class="notice-left">
      <div class="notice-top">
        <div style="width:120px;float:left;">
          <span class="notice-top-checked notice-btn">采购公告</span>
        </div>
        <div style="width:110px;float:left;text-align: center;">
          <span class="notice-top-default result-btn">结果公示</span>
        </div>
        <div style="float:right;padding-top:30px;">
          <router-link style=' line-height: 23px;color: #707070;font-size: 18px;font-family: "Microsoft YaHei";' target="_blank" to="/procurement/notice">更多...</router-link>
        </div>
      </div>
      <div class="notice-content-boxs">
        <div class="notice-font-top" style="margin-bottom:7px;"></div>
        <div class="notice-bottom">

          <div class="notice-con-box" style="width:1420px;">
            <a target="_blank" href="/procurement/notice">
              <div class="notice-con-left" style="position: relative;">
                <div class="notice-row" v-for="notice in noticeList" :key="notice.noticeId">
                  <div style="overflow: hidden">
                    <div style="width:590px;overflow:hidden;position: absolute;font-weight: bold;height:28px;">..........................................................................................................................................................................................</div>
                    <div style="float:left;max-width: 621px;font-weight:bold;background:#fff;position:relative" class="ellipsis">{{notice.noticeTitle}} </div>
                    <div style="float:right;font-weight:bold;">{{notice.noticeTime|dateFormatYMD}}</div>
                  </div>
                  <span>{{notice.noticeContent}}</span>
                </div>
                <div class="notice-row">
                  <div style="overflow: hidden">
                    <div style="float:left;max-width: 621px;font-weight:bold;" class="ellipsis"></div>
                    <div style="float:right;font-weight:bold;"></div>
                  </div>
                  <span></span>
                </div>
              </div>
            </a>
            <a target="_blank" href="/result/public">
              <div class="notice-con-right" style="position: relative;">
                <div class="notice-row" v-for="result in resultList" :key="result.noticeId">
                  <div style="overflow: hidden">
                    <div style="width:590px;overflow:hidden;position: absolute;font-weight: bold;height:28px;">..........................................................................................................................................................................................</div>
                    <div style="float:left;max-width: 621px;font-weight:bold;background:#fff;position:relative" class="ellipsis">{{result.noticeTitle}} </div>
                    <div style="float:right;font-weight:bold;">{{result.noticeTime|dateFormatYMD}}</div>
                  </div>
                  <span>{{result.noticeContent}}</span>
                </div>
                <div class="notice-row">
                  <div style="overflow: hidden">
                    <div style="float:left;max-width: 621px;font-weight:bold;" class="ellipsis"></div>
                    <div style="float:right;font-weight:bold;"></div>
                  </div>
                  <span></span>
                </div>
              </div>
            </a>
          </div>

        </div>
        <div class="notice-font-bottom" style="margin-top:7px;"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { listPortalNotice } from '@/services/notice-service';
import $ from 'jquery';
export default {
  name: 'PurchaseAnnouncement',
  data() {
    return {
      noticeList: [],
      resultList: [],
      timerLeft: null,
      timerRight: null,
      timeCount: 0
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  beforeDestroy: function() {
    clearInterval(this.timerLeft);
    clearInterval(this.timerRight);
    this.timerLeft = null;
    this.timerRight = null;
    this.timeCount = 0;
  },
  methods: {
    async init() {
      try {
        let { data } = await listPortalNotice();
        if (data.returnCode === '01') {
          this.noticeList = data.noticeList;
          this.resultList = data.resultList;
          this.noticeAnimate();
        } else {
          this.$message.error('获取公告列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    noticeAnimate() {
      var _this = this;
      this.timerLeft = setInterval(notice, 50, '.notice-con-left');

      $('.result-btn').click(function() {
        clearInterval(_this.timerRight);
        clearInterval(_this.timerLeft);
        $('.notice-con-box')
          .stop()
          .animate({ marginLeft: -709 }, 100, function() {
            _this.timeCount = 0;
            $('.notice-con-left').css('top', '0');
            _this.timerRight = setInterval(notice, 50, '.notice-con-right');
          });
        $('.notice-top')
          .find('.notice-top-checked')
          .addClass('notice-top-default')
          .removeClass('notice-top-checked');
        $(this)
          .addClass('notice-top-checked')
          .removeClass('notice-top-default');
      });
      $('.notice-btn').click(function() {
        clearInterval(_this.timerRight);
        clearInterval(_this.timerLeft);
        $('.notice-con-box')
          .stop()
          .animate({ marginLeft: 0 }, 100, function() {
            _this.timeCount = 0;
            $('.notice-con-right').css('top', '0');
            _this.timerLeft = setInterval(notice, 50, '.notice-con-left');
          });
        $('.notice-top')
          .find('.notice-top-checked')
          .addClass('notice-top-default')
          .removeClass('notice-top-checked');
        $(this)
          .addClass('notice-top-checked')
          .removeClass('notice-top-default');
      });

      function notice(element) {
        $(element).css('top', _this.timeCount);

        if (_this.timeCount === -282) {
          $(element).append(
            $(element)
              .find('.notice-row:first')
              .clone()
          );
          $(element)
            .find('.notice-row:first')
            .remove();
          $(element).append(
            $(element)
              .find('.notice-row:first')
              .clone()
          );
          $(element)
            .find('.notice-row:first')
            .remove();
          $(element).append(
            $(element)
              .find('.notice-row:first')
              .clone()
          );
          $(element)
            .find('.notice-row:first')
            .remove();
          $(element).css('top', '0');
          _this.timeCount = 0;
        } else {
          _this.timeCount--;
        }
      }

      $('.notice-content-boxs').on('mouseenter', function() {
        $('.notice-font-top').animate({ opacity: 1 }, 100);
        $('.notice-font-bottom').animate({ opacity: 1 }, 100);
        clearInterval(_this.timerRight);
        clearInterval(_this.timerLeft);
      });
      $('.notice-content-boxs').on('mouseleave', function() {
        $('.notice-font-top').animate({ opacity: 0 }, 100);
        $('.notice-font-bottom').animate({ opacity: 0 }, 100);
        if ($('.notice-top-checked').html() === '采购公告') {
          _this.timerLeft = setInterval(notice, 50, '.notice-con-left');
        } else if ($('.notice-top-checked').html() === '结果公示') {
          _this.timerRight = setInterval(notice, 50, '.notice-con-right');
        }
      });
      $('.notice-font-bottom').on('click', function() {
        var element = '.notice-con-left';
        if ($('.notice-top-checked').html() === '采购公告') {
          element = '.notice-con-left';
        } else if ($('.notice-top-checked').html() === '结果公示') {
          element = '.notice-con-right';
        }
        $(element)
          .stop()
          .animate({ top: -282 }, function() {
            $(element).append(
              $(element)
                .find('.notice-row:first')
                .clone()
            );
            $(element)
              .find('.notice-row:first')
              .remove();
            $(element).append(
              $(element)
                .find('.notice-row:first')
                .clone()
            );
            $(element)
              .find('.notice-row:first')
              .remove();
            $(element).append(
              $(element)
                .find('.notice-row:first')
                .clone()
            );
            $(element)
              .find('.notice-row:first')
              .remove();
            $(element).css('top', '0');
            _this.timeCount = 0;
          });
      });
      $('.notice-font-top').on('click', function() {
        var element = '.notice-con-left';
        if ($('.notice-top-checked').html() === '采购公告') {
          element = '.notice-con-left';
        } else if ($('.notice-top-checked').html() === '结果公示') {
          element = '.notice-con-right';
        }
        $(element).css('top', -282);
        $(element).prepend(
          $(element)
            .find('.notice-row:last')
            .clone()
        );
        $(element)
          .find('.notice-row:last')
          .remove();
        $(element).prepend(
          $(element)
            .find('.notice-row:last')
            .clone()
        );
        $(element)
          .find('.notice-row:last')
          .remove();
        $(element).prepend(
          $(element)
            .find('.notice-row:last')
            .clone()
        );
        $(element)
          .find('.notice-row:last')
          .remove();
        $(element)
          .stop()
          .animate({ top: 0 }, function() {
            _this.timeCount = 0;
          });
      });
    }
  }
};
</script>
<style scoped lang="less">
#PurchaseAnnouncement {
  .notice-left {
    height: 385px;
    width: 709px;
    float: left;
    margin-right: 90px;
    margin-left: 100px;
  }
  .notice-left .notice-top {
    height: 68px;
  }
  .notice-left .notice-top-checked {
    font-family: 'Microsoft YaHei';
    font-size: 24px;
    padding-bottom: 6px;
    border-bottom: 1px solid #2a85cb;
    color: #707070;
    line-height: 74px;
    cursor: pointer;
    font-weight: bold;
  }
  .notice-left .notice-top-default {
    font-family: 'Microsoft YaHei';
    font-size: 18px;
    color: #707070;
    line-height: 80px;
    cursor: pointer;
  }
  .notice-left .notice-bottom {
    height: 279px;
    overflow: hidden;
  }
  .notice-left .notice-con-left {
    height: 279px;
    width: 709px;
    float: left;
  }
  .notice-left .notice-con-right {
    float: left;
    height: 279px;
    width: 709px;
  }
  .notice-left .notice-row {
    height: 68px;
    margin-bottom: 26px;
  }
  .notice-left .notice-row:hover div {
    color: #080808;
  }
  .notice-left .notice-row:hover span {
    color: #2f2f2f;
  }
  .notice-left .notice-row div {
    font-family: 'Microsoft YaHei';
    font-size: 14px;
    color: #757474;
    line-height: 28px;
  }
  .notice-left .notice-row span {
    font-family: '宋体';
    font-size: 14px;
    color: #8e8e8e;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .notice-left .notice-font-top {
    height: 11px;
    width: 100%;
    cursor: pointer;
    opacity: 0;
    background: #efefef url(../../assets/img/font-top.jpg) no-repeat center center;
  }
  .notice-left .notice-font-bottom {
    height: 11px;
    width: 100%;
    cursor: pointer;
    opacity: 0;
    background: #efefef url(../../assets/img/font-bottom.jpg) no-repeat center center;
  }
}
</style>
